import React from 'react';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import styles from './CallSupportButton.module.scss';
import { useFreshchat } from '@/features/support/hooks/useFreshchat';

export const CallSupportButton: React.FC = () => {
  const { showWidget } = useFreshchat();

  return (
    <Button
      trackingId="call_support_team"
      onClick={() => showWidget()}
      variant="outlined"
      className={styles.callButton}
      leftIcon={<Icon name="phone" />}
      text="Sună la echipa de suport"
    />
  );
};
